export const environment = {
    production: false,
    apiUrl: 'https://apiv2.knibble.ai/'
    // apiUrl: 'http://localhost:5002/'
};